const normalizarDescricaoCargo = (descricao = "") =>
  String(descricao)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

export const operadorTemCargo = (operador, descricaoCargo) => {
  const descricaoEsperada = normalizarDescricaoCargo(descricaoCargo);

  return (operador?.cargos ?? []).some((cargo) =>
    normalizarDescricaoCargo(
      cargo?.descricao ?? cargo?.Descrição ?? cargo?.["DescriÃ§Ã£o"]
    ) === descricaoEsperada
  );
};

export const operadorEhGerente = (operador) =>
  operadorTemCargo(operador, "Gerente");

export const operadorEhAdmin = (operador) =>
  Number(operador?.permissaoPrincipal) === 99 ||
  operadorTemCargo(operador, "Administrador");

export const operadorEhAdminOuGerente = (operador) =>
  [90, 99].includes(Number(operador?.permissaoPrincipal)) ||
  operadorTemCargo(operador, "Administrador") ||
  operadorEhGerente(operador);
